// The chat hours published on /contact, kept in New Zealand time whatever the visitor's clock
// says: 8 AM - 8 PM Monday to Friday, 10 AM - 6 PM Saturday, closed Sunday. The page hides the
// "chat with us" option outside them. Public holidays are not modelled - the site has no holiday
// calendar - so on those days the option shows and Talkdesk's own after-hours handling answers.

export type Weekday = 'Mon' | 'Tue' | 'Wed' | 'Thu' | 'Fri' | 'Sat' | 'Sun';

/** [opens, closes) as hours on the 24h clock; null = closed all day. */
export const CHAT_HOURS: Record<Weekday, readonly [number, number] | null> = {
  Mon: [8, 20],
  Tue: [8, 20],
  Wed: [8, 20],
  Thu: [8, 20],
  Fri: [8, 20],
  Sat: [10, 18],
  Sun: null,
};

const NZ_CLOCK = new Intl.DateTimeFormat('en-US', {
  timeZone: 'Pacific/Auckland',
  weekday: 'short',
  hour: 'numeric',
  minute: 'numeric',
  hourCycle: 'h23',
});

/** The weekday and minutes-since-midnight in Auckland at `date` (DST included). */
export function nzClock(date: Date = new Date()): { weekday: Weekday; minutes: number } {
  let weekday: Weekday = 'Mon';
  let hour = 0;
  let minute = 0;
  for (const part of NZ_CLOCK.formatToParts(date)) {
    if (part.type === 'weekday') weekday = part.value as Weekday;
    else if (part.type === 'hour') hour = parseInt(part.value, 10);
    else if (part.type === 'minute') minute = parseInt(part.value, 10);
  }
  return { weekday, minutes: hour * 60 + minute };
}

export function isWithinChatHours(date: Date = new Date()): boolean {
  const { weekday, minutes } = nzClock(date);
  const hours = CHAT_HOURS[weekday];
  if (!hours) {
    return false;
  }
  const [opens, closes] = hours;
  return minutes >= opens * 60 && minutes < closes * 60;
}
